import React from 'react';
import Carousel from "react-material-ui-carousel"
import autoBind from "auto-bind"
import clsx from 'clsx';
import { UserContext } from '../components/userContext';
import { useHistory } from 'react-router';
import {
    Card,
    CardContent,
    CardMedia,
    Typography,
    Grid,
    Hidden,
    Button,
    Checkbox,
    FormControlLabel,
    Radio,
    RadioGroup,
    FormLabel,
    Slider,
    makeStyles,
    withStyles,
    CssBaseline,
} from '@material-ui/core';
import RemoveIcon from '@material-ui/icons/Remove';

const useStyles = makeStyles({
  banner: {
    height: "400px",
    position: "relative",
    minWidth: 275,
    "& .media": {
      backgroundColor: "white",
      height: "100%",
      position: "relative",
      transition: "300ms",
      cursor: "pointer",
      '@media (max-width:1279px)': {
        display: 'none'
      },
      "&:hover": {
        filter: "brightness(115%)",
        backgroundSize: 'auto 110%'
      },
      "& .mediaCaption": {
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        position: "absolute",
        bottom: "0",
        padding: "15px",
        backgroundColor: "black",
        color: "white",
        opacity: "0.6",
        width: "100%",
        fontSize: "25px",
        fontWeight: "200",
        transition: "300ms",
        cursor: "pointer",
        "&:hover": {
          opacity: "0.8"
        }
      }
    },
    "& .bannerGrid": {
      height: "100%",
      position: "relative"
    },
    "& .content": {
      color: "white",
      backgroundColor: "rgba(26, 26, 26, 0.9)",
      height: "100%",
      position: "relative",
      cursor: "pointer",
      padding: "30px",
      transition: "300ms",
      '@media (max-width:1279px)': {
        backgroundColor: "transparent",
      },
      // "&:hover, &:active": {
      //   backgroundColor: "transparent",
      //   color: 'rgba(8, 8, 8, 0.975)'
        // '& .viewButton': {
        //   backgroundColor: "rgb(241, 241, 241)",
        //   color: "rgb(119, 24, 24)"
        // }
      // },
      "& .title": {
        fontSize: "40px",
        fontWeight: "500",
      },
      "& .caption": {
        marginTop: "10px",
        fontSize: "21px"
      },
      "& .viewButton": {
        marginTop: "40px",
        color: "white",
        fontSize: "25px",
        // border: "3px solid white",
        borderRadius: 0,
        textTransform: "capitalize",
        transition: "200ms",
        '&:hover': {
          // color: "rgb(163, 102, 255)",
          // border: 'none',
          // backgroundColor: "rgba(26, 26, 26, 0.975)"
        }
      }
    }
  }
});

function Banner(props) {
  const classes = useStyles();
  let history = useHistory();
  if (props.newProp) console.log(props.newProp)
  const contentPosition = props.contentPosition ? props.contentPosition : "left"
  const totalItems = props.length ? props.length : 3;
  const mediaLength = totalItems - 1;
  
  let items = [];
  const content = (
    <Grid item xs={12} lg={12 / totalItems} key="content" style={{background: `url(${props.item.bgImage}) center/cover no-repeat`}}>
      <CardContent className="content">
        <Typography className="title">
          {props.item.Name}
        </Typography>

        <Typography className="caption">
          {props.item.Caption}
        </Typography>

        {props.item.Name === "Games" &&
        <Button variant="outlined" className="viewButton" onClick={() => history.push(`/games`)}>
          More
        </Button>}

        {props.item.Name === "Movies" &&
        <Button variant="outlined" className="viewButton" onClick={() => history.push(`/movies`)}>
          More
        </Button>}
      </CardContent>
    </Grid>
  )

  for (let i = 0; i < mediaLength; i++) {
    const item = props.item.Items[i];

    const media = (
      <Grid item xs lg={12 / totalItems} key={item.Name}>
        <CardMedia
          className="media"
          image={item.Image}
          title={item.Name}
        >
          <Typography className="mediaCaption">
            {item.Name}
          </Typography>
        </CardMedia>
      </Grid>
    )
    items.push(media);
  }

  if (contentPosition === "left") {
    items.unshift(content);
  } else if (contentPosition === "right") {
    items.push(content);
  } else if (contentPosition === "middle") {
    items.splice(items.length / 2, 0, content);
  }

  return (
    <Card raised className={classes.banner}>
      <Grid container spacing={0} className="bannerGrid">
        {items}
      </Grid>
    </Card>
  )
}

const items = [
  {
    Name: "Movies",
    Caption: "Upcoming Movie 2021!",
    contentPosition: "left",
    bgImage: "https://images.alphacoders.com/115/thumb-1920-1159905.jpg", 
    Items: [
      {
        Name: "Black Widow",
        Image: "https://images5.alphacoders.com/107/thumb-1920-1079623.jpg"
      },
      {
        Name: "Venom : Let There Be Carnage",
        Image: "https://images.alphacoders.com/115/thumb-1920-1156748.jpg"
      }
    ]
  },
  {
    Name: "Movies",
    Caption: "All Time Worldwide Box Office",
    contentPosition: "middle",
    bgImage: "https://images.alphacoders.com/440/thumb-1920-44041.jpg", 
    Items: [
      {
        Name: "Avengers: End Game (2019)",
        Image: "https://images5.alphacoders.com/100/thumb-1920-1008656.jpg"
      },
      {
        Name: "The Dark Knight (2008)",
        Image: "https://images4.alphacoders.com/714/thumb-1920-71426.jpg"
      }
    ]
  },
  {
    Name: "Games",
    Caption: "Most Popular PC Games!",
    contentPosition: "middle",
    bgImage: "https://estnn.com/wp-content/uploads/2021/03/Wow-Classic.jpg",
    Items: [
      {
        Name: "Dota 2 (Online)",
        Image: "https://images6.alphacoders.com/342/thumb-1920-342127.jpg"
      },
      {
        Name: "World of Warcraft (Online)",
        Image: "https://www.revivaltv.id/wp-content/uploads/2020/02/World-of-Warcraft-classic-onyxia-1280x720-1.jpg"
      }
    ]
  },
  {
    Name: "Games",
    Caption: "Most Popular Mobile Games!",
    contentPosition: "right",
    bgImage: "https://i.pinimg.com/originals/6e/a6/7f/6ea67f4512b65ae369dc4b566c390402.jpg",
    Items: [
      {
        Name: "Genshin Impact (Online)",
        Image: "https://images.alphacoders.com/112/thumb-1920-1123761.jpg"
      },
      {
        Name: "Mobile Legend (Online)",
        Image: "https://images2.alphacoders.com/100/thumb-1920-1001946.jpg"
      }
    ]
  }
]

const useStyles2 = (theme) => ({
  carousel: {
    // boxSizing: 'border-box',
    height: 'calc(100vh - 56px - 52px - 40px)', 
    '& .Carousel-indicators-38': {
      '& .MuiIconButton-root:hover': {
        backgroundColor: 'transparent'
      },
    },
    '@media (max-width:599px)': {
      height: 'calc(100vh - 48px - 52px - 24px)', 
    }
  },
  carouselUser: {
    // boxSizing: 'border-box',
    height: 'calc(100vh - 56px - 48px - 52px - 40px)', 
    '@media (max-width:599px)': {
      height: 'calc(100vh - 48px - 40px - 52px - 24px)', 
    }
  },
  clvContainer: {
    height: 'calc(100vh - 56px)', 
    width: 'auto', 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    marginTop: '-40px',
    '@media (max-width:599px)': {
      height: 'calc(100vh - 48px)', 
      marginTop: '-24px',
    }
  },
  clvContainerUser: {
    height: 'calc(100vh - 56px - 48px)', 
    '@media (max-width:599px)': {
      height: 'calc(100vh - 48px - 40px)', 
    }
  },
});

class HomePage extends React.Component {
  static contextType = UserContext;
  
  constructor(props) {
    super(props);
    this.state = {
      interval: 7000,
      autoPlay: true,
      animation: "slide",
      indicators: true,
      timeout: 750,
      navButtonsAlwaysVisible: false,
      navButtonsAlwaysInvisible: false,
      navButtonsWrapperProps: {
        style: {
          top: '0px',
          height: `calc(100% - 30px)`,
        }
      },
      cycleNavigation: true,
      indicatorIconButtonProps: {
        style: {
          color: '#494949',
          width: '20px',
          height: '20px',
        }
      },
      indicatorContainerProps: {
        style: {
          margin: 0,
          height: '30px',
        }
      },
      activeIndicatorIconButtonProps: {
        style: {
          color: '#fff'
        }
      }
    }
    autoBind(this);
  }

  tes(){

    const logo = document.querySelectorAll('#clvsvg path')
    console.log(logo)
    for(let i=0; i<logo.length; i++) {
      console.log(`LEtter ${i} is ${logo[i].getTotalLength()}`)
    }
  }
  // toggleAutoPlay() {
  //   this.setState({
  //     autoPlay: !this.state.autoPlay
  //   })
  // }

  // toggleIndicators() {
  //   this.setState({
  //     indicators: !this.state.indicators
  //   })
  // }

  // toggleNavButtonsAlwaysVisible() {
  //   this.setState({
  //     navButtonsAlwaysVisible: !this.state.navButtonsAlwaysVisible
  //   })
  // }

  // toggleNavButtonsAlwaysInvisible() {
  //   this.setState({
  //     navButtonsAlwaysInvisible: !this.state.navButtonsAlwaysInvisible
  //   })
  // }

  // toggleCycleNavigation() {
  //   this.setState({
  //     cycleNavigation: !this.state.cycleNavigation
  //   })
  // }

  // changeAnimation(event) {
  //   this.setState({
  //     animation: event.target.value
  //   })
  // }

  // changeTimeout(event, value) {
  //   this.setState({
  //     timeout: value
  //   })
  // }

  render() {
    const { classes } = this.props;
    const { user } = this.context;
    return (
      <>
        <CssBaseline />
        <div className={clsx(classes.clvContainer, user && classes.clvContainerUser)}>
          <svg id="clvsvg" width="776" height="143" viewBox="0 0 776 143" fill="none" xmlns="http://www.w3.org/2000/svg">
            {/* <mask id="path-1-outside-1" maskUnits="userSpaceOnUse" x="0.461548" y="-0.296021" width="775" height="143" fill="black">
              <rect fill="white" x="0.461548" y="-0.296021" width="775" height="143"/>
              <path d="M3.47199 64.48C2.89599 91.696 26.224 114.304 54.016 113.728C72.304 113.728 87.856 104.944 96.064 90.112L81.376 79.744C74.608 90.4 65.536 95.728 54.16 95.728C36.448 95.728 23.488 82.768 23.488 64.624C23.488 46.48 36.448 33.232 54.16 33.232C65.536 33.232 74.608 38.56 81.376 49.216L96.064 38.848C87.568 24.016 72.16 15.232 54.16 15.232C26.512 14.656 3.03999 37.264 3.47199 64.48Z"/>
              <path d="M111.289 112H130.729V3.99998H111.289V112Z"/>
              <path d="M209.72 69.664C209.72 49.936 197.768 39.136 179.192 39.136C166.664 39.136 156.296 44.032 148.088 53.824L158.168 65.776C164.504 59.008 169.688 55.984 177.032 55.984C185.672 55.984 190.28 60.592 190.28 68.512V71.68H172.424C155.864 71.68 145.496 79.6 145.496 92.416C145.496 104.944 155 113.728 170.12 113.728C179.192 113.728 186.68 110.416 191.864 105.088V112H209.72V69.664ZM190.28 85.36C190.28 93.568 183.8 99.472 175.304 99.472C169.112 99.472 165.08 96.448 165.08 91.696C165.08 86.944 168.68 84.496 175.016 84.496H190.28V85.36Z"/>
              <path d="M228.429 112H247.869V40.72H228.429V112ZM225.693 14.8C225.693 21.568 231.165 26.752 238.077 26.752C244.989 26.752 250.605 21.568 250.605 14.8C250.605 7.88798 244.989 2.70398 238.077 2.70398C231.165 2.70398 225.693 7.88798 225.693 14.8Z"/>
              <path d="M310.877 40.72C309.005 40.144 306.989 39.856 304.541 39.856C296.621 39.856 289.709 43.312 284.957 49.216V40.72H267.101V112H286.541V76.432C286.541 64.192 294.029 57.856 305.693 57.856H310.877V40.72Z"/>
              <path d="M371.457 40.72L353.457 81.04L335.457 40.72H315.009L350.289 113.728H356.769L392.049 40.72H371.457Z"/>
              <path d="M396.522 76.288C396.09 96.592 413.658 114.016 434.538 113.584C455.418 114.016 473.418 96.592 472.986 76.288C473.418 55.984 455.562 38.848 434.682 39.136C413.802 38.704 396.09 55.984 396.522 76.288ZM453.114 76.432C453.114 87.52 445.194 95.728 434.682 95.728C423.882 95.728 416.25 87.52 416.25 76.432C416.25 65.056 423.882 56.848 434.682 56.848C445.194 56.848 453.114 65.344 453.114 76.432Z"/>
              <path d="M535.429 40.72L516.853 87.52L499.429 40.72H478.837L506.197 107.68L504.037 112.576C500.725 120.064 496.117 122.224 489.205 122.224C488.053 122.224 485.317 122.08 480.853 121.648V137.92C485.173 139.072 489.349 139.648 493.381 139.648C506.629 139.648 515.269 133.024 521.749 118.192L555.877 40.72H535.429Z"/>
              <path d="M624.142 69.664C624.142 49.936 612.19 39.136 593.614 39.136C581.086 39.136 570.718 44.032 562.51 53.824L572.59 65.776C578.926 59.008 584.11 55.984 591.454 55.984C600.094 55.984 604.702 60.592 604.702 68.512V71.68H586.846C570.286 71.68 559.918 79.6 559.918 92.416C559.918 104.944 569.422 113.728 584.542 113.728C593.614 113.728 601.102 110.416 606.286 105.088V112H624.142V69.664ZM604.702 85.36C604.702 93.568 598.222 99.472 589.726 99.472C583.534 99.472 579.502 96.448 579.502 91.696C579.502 86.944 583.102 84.496 589.438 84.496H604.702V85.36Z"/>
              <path d="M708.371 67.792C708.371 50.512 698.147 39.136 681.587 39.136C673.091 39.136 665.747 42.16 660.707 47.2V40.72H642.851V112H662.291V70.384C662.291 62.176 667.907 56.56 675.827 56.56C683.747 56.56 689.075 62.176 689.075 70.384V112H708.371V67.792Z"/>
              <path d="M772.878 95.728C767.838 96.16 764.814 96.304 763.661 96.304C754.445 96.304 750.414 93.28 750.414 85.216V57.136H770.573V40.72H750.414V22.72H730.974V40.72H719.742V57.136H730.974V86.944C730.974 104.8 741.485 113.728 759.485 113.728C763.805 113.728 768.27 113.152 772.878 112V95.728Z"/>
            </mask> */}
            <path 
              d="M3.47199 64.48C2.89599 91.696 26.224 114.304 54.016 113.728C72.304 113.728 87.856 104.944 96.064 90.112L81.376 79.744C74.608 90.4 65.536 95.728 54.16 95.728C36.448 95.728 23.488 82.768 23.488 64.624C23.488 46.48 36.448 33.232 54.16 33.232C65.536 33.232 74.608 38.56 81.376 49.216L96.064 38.848C87.568 24.016 72.16 15.232 54.16 15.232C26.512 14.656 3.03999 37.264 3.47199 64.48Z" 
              stroke="white" 
              stroke-width="2" 
              // mask="url(#path-1-outside-1)"
            />
            <path 
              d="M111.289 112H130.729V3.99998H111.289V112Z" 
              stroke="white" 
              stroke-width="2" 
              // mask="url(#path-1-outside-1)"
            />
            <path 
              d="M209.72 69.664C209.72 49.936 197.768 39.136 179.192 39.136C166.664 39.136 156.296 44.032 148.088 53.824L158.168 65.776C164.504 59.008 169.688 55.984 177.032 55.984C185.672 55.984 190.28 60.592 190.28 68.512V71.68H172.424C155.864 71.68 145.496 79.6 145.496 92.416C145.496 104.944 155 113.728 170.12 113.728C179.192 113.728 186.68 110.416 191.864 105.088V112H209.72V69.664ZM190.28 85.36C190.28 93.568 183.8 99.472 175.304 99.472C169.112 99.472 165.08 96.448 165.08 91.696C165.08 86.944 168.68 84.496 175.016 84.496H190.28V85.36Z" 
              stroke="white" 
              stroke-width="2" 
              // mask="url(#path-1-outside-1)"
            />
            <path 
              d="M228.429 112H247.869V40.72H228.429V112ZM225.693 14.8C225.693 21.568 231.165 26.752 238.077 26.752C244.989 26.752 250.605 21.568 250.605 14.8C250.605 7.88798 244.989 2.70398 238.077 2.70398C231.165 2.70398 225.693 7.88798 225.693 14.8Z" 
              stroke="white" 
              stroke-width="2" 
              // mask="url(#path-1-outside-1)"
            />
            <path 
              d="M310.877 40.72C309.005 40.144 306.989 39.856 304.541 39.856C296.621 39.856 289.709 43.312 284.957 49.216V40.72H267.101V112H286.541V76.432C286.541 64.192 294.029 57.856 305.693 57.856H310.877V40.72Z" 
              stroke="white" 
              stroke-width="2" 
              // mask="url(#path-1-outside-1)"
            />
            <path 
              d="M371.457 40.72L353.457 81.04L335.457 40.72H315.009L350.289 113.728H356.769L392.049 40.72H371.457Z" 
              stroke="white" 
              stroke-width="2" 
              // mask="url(#path-1-outside-1)"
            />
            <path 
              d="M396.522 76.288C396.09 96.592 413.658 114.016 434.538 113.584C455.418 114.016 473.418 96.592 472.986 76.288C473.418 55.984 455.562 38.848 434.682 39.136C413.802 38.704 396.09 55.984 396.522 76.288ZM453.114 76.432C453.114 87.52 445.194 95.728 434.682 95.728C423.882 95.728 416.25 87.52 416.25 76.432C416.25 65.056 423.882 56.848 434.682 56.848C445.194 56.848 453.114 65.344 453.114 76.432Z" 
              stroke="white" 
              stroke-width="2" 
              // mask="url(#path-1-outside-1)"
            />
            <path 
              d="M535.429 40.72L516.853 87.52L499.429 40.72H478.837L506.197 107.68L504.037 112.576C500.725 120.064 496.117 122.224 489.205 122.224C488.053 122.224 485.317 122.08 480.853 121.648V137.92C485.173 139.072 489.349 139.648 493.381 139.648C506.629 139.648 515.269 133.024 521.749 118.192L555.877 40.72H535.429Z" 
              stroke="white" 
              stroke-width="2" 
              // mask="url(#path-1-outside-1)"
            />
            <path 
              d="M624.142 69.664C624.142 49.936 612.19 39.136 593.614 39.136C581.086 39.136 570.718 44.032 562.51 53.824L572.59 65.776C578.926 59.008 584.11 55.984 591.454 55.984C600.094 55.984 604.702 60.592 604.702 68.512V71.68H586.846C570.286 71.68 559.918 79.6 559.918 92.416C559.918 104.944 569.422 113.728 584.542 113.728C593.614 113.728 601.102 110.416 606.286 105.088V112H624.142V69.664ZM604.702 85.36C604.702 93.568 598.222 99.472 589.726 99.472C583.534 99.472 579.502 96.448 579.502 91.696C579.502 86.944 583.102 84.496 589.438 84.496H604.702V85.36Z" 
              stroke="white" 
              stroke-width="2" 
              // mask="url(#path-1-outside-1)"
            />
            <path 
              d="M708.371 67.792C708.371 50.512 698.147 39.136 681.587 39.136C673.091 39.136 665.747 42.16 660.707 47.2V40.72H642.851V112H662.291V70.384C662.291 62.176 667.907 56.56 675.827 56.56C683.747 56.56 689.075 62.176 689.075 70.384V112H708.371V67.792Z" 
              stroke="white" 
              stroke-width="2" 
              // mask="url(#path-1-outside-1)"
            />
            <path 
              d="M772.878 95.728C767.838 96.16 764.814 96.304 763.661 96.304C754.445 96.304 750.414 93.28 750.414 85.216V57.136H770.573V40.72H750.414V22.72H730.974V40.72H719.742V57.136H730.974V86.944C730.974 104.8 741.485 113.728 759.485 113.728C763.805 113.728 768.27 113.152 772.878 112V95.728Z" 
              stroke="white" 
              stroke-width="2" 
              // mask="url(#path-1-outside-1)"
            />
          </svg>
        </div>
        <div className={clsx(classes.carousel, user && classes.carouselUser)}>
          <Carousel
            className="Example"
            autoPlay={this.state.autoPlay}
            animation={this.state.animation}
            indicators={this.state.indicators}
            timeout={this.state.timeout}
            cycleNavigation={this.state.cycleNavigation}
            navButtonsAlwaysVisible={this.state.navButtonsAlwaysVisible}
            navButtonsAlwaysInvisible={this.state.navButtonsAlwaysInvisible}
            navButtonsWrapperProps={this.state.navButtonsWrapperProps}
            indicatorIconButtonProps={this.state.indicatorIconButtonProps}
            indicatorContainerProps={this.state.indicatorContainerProps}
            IndicatorIcon={<RemoveIcon fontSize="large"/>}
            activeIndicatorIconButtonProps={this.state.activeIndicatorIconButtonProps}
            next={(now, previous) => console.log(`Next User Callback: Now displaying child${now}. Previously displayed child${previous}`)}
            prev={(now, previous) => console.log(`Prev User Callback: Now displaying child${now}. Previously displayed child${previous}`)}
            onChange={(now, previous) => console.log(`OnChange User Callback: Now displaying child${now}. Previously displayed child${previous}`)}
            // fullHeightHover={false}
            navButtonsProps={{style: {padding: 8}}}
            // navButtonsWrapperProps={{style: {bottom: '0', top: 'unset', }}}
            // indicatorContainerProps={{style: {margin: "20px"}}}
            // NextIcon='next'
          >
            {
              items.map((item, index) => {
                return <Banner item={item} key={index} contentPosition={item.contentPosition} />
              })
            }
          </Carousel>
          {/* <FormLabel component="legend">Options</FormLabel>
          <FormControlLabel
            control={<Checkbox onChange={this.toggleAutoPlay} checked={this.state.autoPlay} value="autoplay" color="primary" />}
            label="Auto-play"
          />
          <FormControlLabel
            control={<Checkbox onChange={this.toggleIndicators} checked={this.state.indicators} value="indicators" color="primary" />}
            label="Indicators"
          />
          <FormControlLabel
            control={<Checkbox onChange={this.toggleNavButtonsAlwaysVisible} checked={this.state.navButtonsAlwaysVisible} value="NavButtonsAlwaysVisible" color="primary" />}
            label="NavButtonsAlwaysVisible"
          />
          <FormControlLabel
            control={<Checkbox onChange={this.toggleNavButtonsAlwaysInvisible} checked={this.state.navButtonsAlwaysInvisible} value="NavButtonsAlwaysInvisible" color="primary" />}
            label="NavButtonsAlwaysInvisible"
          />
          <FormControlLabel
            control={<Checkbox onChange={this.toggleCycleNavigation} checked={this.state.cycleNavigation} value="CycleNavigation" color="primary" />}
            label="CycleNavigation"
          />
          <FormControlLabel
            control={
              <RadioGroup name="animation" value={this.state.animation} onChange={this.changeAnimation} row style={{ marginLeft: "10px" }}>
                <FormControlLabel value="fade" control={<Radio color="primary" />} label="Fade" />
                <FormControlLabel value="slide" control={<Radio color="primary" />} label="Slide" />
              </RadioGroup>
            }
          />
          <FormControlLabel
            control={
              <div style={{ width: 300 }}>
                <Typography id="discrete-slider" gutterBottom>
                  Animation Duration (Timeout) in ms
                </Typography>
                <Slider
                  defaultValue={500}
                  getAriaValueText={() => `${this.state.timeout}ms`}
                  aria-labelledby="discrete-slider"
                  valueLabelDisplay="auto"
                  step={100}
                  marks
                  min={100}
                  max={2000}
                  onChange={this.changeTimeout}
                />
              </div>
            }
          /> */}
          <div style={{textAlign: 'center'}}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque non ultrices augue. Aliquam porta, eros vitae tincidunt tincidunt, neque purus ornare massa, egestas gravida libero leo ut odio. Nullam pellentesque vel orci non tincidunt. Phasellus porta nisi at blandit blandit. Duis eget sapien bibendum, vulputate leo laoreet, venenatis elit.
          </div>
        </div>
        
      </>
    )
  }
}

export default withStyles(useStyles2)(HomePage);